import React from 'react';
import { useTasksGroupsService } from 'nekst-api';
import { BaseInputProps, Dropdown, LoadingAnimation, Option } from 'ui-builder';
import { useDataLoaderNew } from 'data-loader';
import { TasksGroupIcon } from 'features/nekst-widgets';

export interface TasksGroupsDropdownProps extends BaseInputProps<number> {

}

export function TasksGroupsDropdown(props: TasksGroupsDropdownProps) {

  const tasksGroupsService = useTasksGroupsService();

  const { data: groups } = useDataLoaderNew(tasksGroupsService.getTasksGroups);



  if (groups) {
    const options: Option<number | null>[] = groups.map((group) => {
      return {
        label: <TasksGroupIcon group={group} withName />,
        value: group.id
      };
    });

    return (
      <Dropdown<number | null>
        options={options}
        placeholder="No Group"
        {...props}
      />
    );
  } else {
    return (
      <LoadingAnimation />
    )
  }


}
